import { render } from "./FrequentAsk.vue?vue&type=template&id=59aa61b6&scoped=true"
import script from "./FrequentAsk.vue?vue&type=script&lang=js"
export * from "./FrequentAsk.vue?vue&type=script&lang=js"

import "./FrequentAsk.vue?vue&type=style&index=0&id=59aa61b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59aa61b6"]])

export default __exports__